import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { TBoardId, TCardId } from '../../../../../../../../types/types';
import { pasteCommentMention } from '../../CommentsInputHOC/effects/pasteCommentMention';
import { CLASS_COMMENTS_INPUT } from '../../../components/CommentsInput/constants';
import { commentUpdate } from '../../../store/reducers/actions/commentUpdate';

export const onMention = (
    mentionIndex: number,
    boardId: TBoardId,
    cardId: TCardId
): ThunkAction => {
    return (dispatch: Dispatch) => {
        const input = document.querySelector('.' + CLASS_COMMENTS_INPUT + ' textarea') as HTMLInputElement ||
            document.querySelector(`.${CLASS_COMMENTS_INPUT} .ql-editor`) as HTMLInputElement;

        dispatch(commentUpdate({ highlightedMention: mentionIndex }));
        setTimeout(() => {
            dispatch(pasteCommentMention(input, boardId, cardId));
        }, 100);
        input.focus();
    };
};
